const REVIEWS_HASH = 'reviews';

export { REVIEWS_HASH };
//# sourceMappingURL=constants.js.map
